<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input placeholder="手机号" v-model="params.mobile"><el-button slot="append" icon="el-icon-search" @click="getGiveLogListsearch"></el-button></el-input>
        </el-col>
        <el-col :span="4">
          <el-input placeholder="优惠券id" v-model="params.couponId"><el-button slot="append" icon="el-icon-search" @click="getGiveLogListsearch"></el-button></el-input>
        </el-col>

      </el-row>

      <el-table :data="giveLogList" :height="wheight-90" v-loading="loading">
        <el-table-column label="发放时间">
          <template slot-scope="scope">
            {{scope.row.created_at | datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column prop="number" label="会员卡号ID"> <template slot-scope="scope">
          {{scope.row.card_id}}
        </template></el-table-column>
        <el-table-column prop="error" label="会员手机号"> <template slot-scope="scope">
          {{scope.row.mobile}}
        </template></el-table-column>
        <el-table-column prop="error" label="会员姓名"> <template slot-scope="scope">
          {{scope.row.name}}
        </template></el-table-column>
        <el-table-column prop="sender" label="优惠券ID"><template slot-scope="scope">
          {{scope.row.coupon_id}}
        </template> </el-table-column>
        <el-table-column prop="error" label="优惠券标题"><template slot-scope="scope">
          {{scope.row.title}}
        </template> </el-table-column>
        <el-table-column prop="error" label="状态"><template slot-scope="scope">
          <span v-if="scope.row.send_np_flag == '1'">发送失败</span>
          <span v-else-if="scope.row.send_np_flag == '2'">发送成功</span>
          <span v-else-if="scope.row.send_np_flag == '7'">已删除</span>
          <span v-else-if="scope.row.send_np_flag == '9'">已使用</span>
          <span v-else>失败</span>
        </template> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            
            <i class="mark iconfont icon-trash-alt1" v-if="scope.row.send_np_flag == '2'" @click="delAction(scope.row.id, scope.row.couponmanagid)"></i>

          </template>
        </el-table-column>
      </el-table>
      <div class="content-padded content-center">
        <el-pagination
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="params.page"
          :total='totalCount' :page-size='params.pageSize'>
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getCouponLogList ,delOfflineCoupons} from '../../../api/promotions'
export default {
  data () {
    return {
      loading: false,
      giveLogList: [],
      totalCount: 0,
      params: {
        page: 1,
        pageSize: 20,
        mobile:'',
        couponId:'',
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    handleCurrentChange(pageNum) {
      this.params.page = pageNum
      this.getGiveLogList()
    },
    getGiveLogListsearch(e){
        this.params.page = 1
        this.getGiveLogList()
    },
    delAction(id,couponmanagid){
      
      this.$confirm('是否需要删除优惠券?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var sendparams = {
            couponmanagid:couponmanagid,
            id:id
          }
          delOfflineCoupons(sendparams).then(res => {
            
            if(res.data.data.status=='0'){
              this.$message({
                message: '删除成功',
                type: 'success',
                duration: 5 * 1000
              })
            }else{
              this.$message({
                message: '删除失败',
                type: 'warning',
                duration: 5 * 1000
              })
            }
          })
         // this.getGiveLogList()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      
    },
    getGiveLogList () {
      this.loading = true
      getCouponLogList(this.params).then(response => {
        this.giveLogList = response.data.data.list
        this.totalCount = response.data.data.total_count
        this.loading = false
      }).catch(error => {
        this.loading = false
        this.$message({
          type: 'error',
          message: '获取线下优惠券列表信息出错'
        })
      })
    },
  },
  mounted () {
    this.getGiveLogList()
  }
}
</script>
<style scoped lang="scss">
  .el-icon-edit {
    cursor: pointer;
  }
  .coupon-list {
    margin-top: 10px;
  }
  .coupon-item {
    position: relative;
    height: 130px;
    padding: 25px 20px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dadadd;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
    width: 19%;
    float: left;
    margin: .5%;
    &.coupon-add {
      padding-top: 20px;
      cursor: pointer;
      i {
        font-size: 40px;
      }
      :last-child { margin-top: 10px; }
    }
    .price {
      font-size: 24px;
    }
    .color-gray {
      color: #99A9BF;
    }
    .color-gray-deep {
      color: #8492A6;
    }
    .item-code {
      display: inline-block;
      width: 90%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    span.icon-triangle {
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-top: 34px solid #20a0ff;
      border-left: 34px solid transparent;
      color: #fff;
    }
    label {
      position: absolute;
      top: -34px;
      right: 0;
      width: 20px;
      height: 20px;
      line-height: 20px;
    }
  }
  .item-bg {
    position: absolute;
    left: 0;
    bottom: -101%;
    width: 100%;
    height: 100%;
    background: rgba(241, 244, 246, .9);
    text-align: left;
    border-radius: 5px;
    padding-top: 8px;
    transition: all .4s ease;
    p {
      padding: 0 10px;
    }
    .item-operate {
      position: absolute;
      left: 0;
      bottom: 0;
      background: rgba(0, 0, 0, .4);
      width: 100%;
      padding: 4px 0;
      text-align: center;
      cursor: pointer;
      a { color: #fff; }
    }
  }
  .coupon-item:hover {
    .item-bg {
      bottom: 0;
    }
  }
  .coupon-type-item {
    position: relative;
    padding: 30px 10px;
    border: 1px solid #ff5000;
    color: #ff5000;
    border-radius: 5px;
    text-align: center;
    margin-bottom: 20px;
    background: #fff;
    overflow: hidden;
    cursor: pointer;
    &:first-child {
      font-size: 18px;
    }
    .coupon-type-desc {
      position: absolute;
      width: 100%;
      height: 100%;
      bottom: -100%;
      left: 0;
      padding: 10px 0;
      background: #ff5000;
      color: #fff;
      font-size: 18px;
      transition: all .4s ease;
      div:last-child {
        width: 70%;
        margin: 8px auto 0;
        font-size: 12px;
      }
    }
    &:hover {
      .coupon-type-desc {
        bottom: 0;
      }
    }
  }

  .coupon-type-item, .sendout-item {
    overflow: hidden;
    .icon-checked {
      display: none;
      width: 100px;
      height: 25px;
      transform: rotate(35deg);
      position: absolute;
      font-size: 14;
      top: 5px;
      right: -25px;
      font-size: 20px;
      color: #fff;
      background: #ff5000;
      i {
        transform: rotate(-35deg);
      }
    }
    &.checked {
      .icon-checked {
        display: block;
      }
    }

    &:hover .icon-checked {
      background: #fff;
      i {
        color: #ff5000;
      }
    }
  }
  .store-pop {
    padding: 20px 15px;
    .store-content {
      margin-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// couponLog.vue?4d859bc9